import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import * as MailingAddress from '../../../typeModules/mailingAddress'
import AppDownloadButton, {
  AppDownloadOS,
} from '../../atoms/app-download-button'
import OrientationVideo from '../../atoms/orientation-video'

import { connect } from 'react-redux'
import * as events from '../../../events'

import t from './strings'

type ConfirmationProps = {
  status: string
  mailingAddress: MailingAddress.Type
  trackDropshippingEvent?: (string) => Promise<any>
}

const Confirmation: React.SFC<ConfirmationProps> = props => {
  const { trackDropshippingEvent } = props

  React.useEffect(() => {
    trackDropshippingEvent('DA_dxds_confirmation_page')
  }, [])

  return (
    <div>
      <StackChildren>
        <Text styles={Text.Styles.Bold24}>{t.title()}</Text>
        <Text>{t.activationKit()}</Text>
        <Text>{MailingAddress.getAddressString(props.mailingAddress)}</Text>

        <hr />

        <Text>{t.expectation()}</Text>
        <Text styles={Text.Styles.SectionTitle}>{t.introToDashing()}</Text>
        <OrientationVideo />

        <hr />

        <Text styles={Text.Styles.SectionTitle}>{t.downloadTheApp()}</Text>
        <AppDownloadButton os={AppDownloadOS.IOS} />
        <AppDownloadButton os={AppDownloadOS.ANDROID} />

        <hr />

        <Text styles={Text.Styles.SectionTitle}>{t.haveQuestions()}</Text>
        <Text
          href="https://dasherhelp.doordash.com/"
          target={'_blank'}
          tag={'a'}
        >
          {t.dasherHelpCenter()}
        </Text>
      </StackChildren>
    </div>
  )
}

export const DisconnectedConfirmation = Confirmation

const mapDispatchToProps = {
  trackDropshippingEvent: events.trackDropshippingEvent,
}

export default connect(null, mapDispatchToProps)(Confirmation)
